import { FC, InputHTMLAttributes } from 'react';
import { IMaskInput, IMaskInputProps } from 'react-imask';

import { getInputAria } from './Input.helpers';
import { InputBase } from './Input.type';
import { FieldWrapper } from './atoms/FieldWrapper';

type Props = Prettify<
  InputBase<string> &
    Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'ref'> & {
      mask: string | { type: 'number'; scale?: number };
      onChange: (value: string) => void;
    }
>;

const parseNumber = (value: number | string | undefined) => {
  return value ? Number.parseInt(value.toString()) : undefined;
};

export const InputMasked: FC<Props> = ({
  className,
  inputClassName,
  mask,
  onChange,
  label,
  placeholder,
  labelOutside,
  value,
  min,
  max,
  ...props
}) => {
  // Build mask props conditionally based on mask type
  const maskProps: IMaskInputProps<HTMLInputElement> =
    typeof mask === 'string'
      ? {
          mask: mask,
        }
      : {
          mask: Number,
          min: parseNumber(min),
          max: parseNumber(max),
          thousandsSeparator: ',',
          radix: '.',
          scale: mask.scale,
        };

  return (
    <FieldWrapper {...props} label={label} className={className} labelOutside={labelOutside}>
      <IMaskInput
        {...props}
        {...getInputAria(props)}
        {...maskProps}
        defaultValue={value}
        onAccept={(value: string) => onChange(value)}
        className={inputClassName}
        placeholder={placeholder ?? ' '} // placeholder must to be " " when nullish to avoid ios styling issues
        data-testid={props['data-testid']}
      />
    </FieldWrapper>
  );
};
